import { useSearchParams } from 'react-router-dom';
import { memo } from 'react';

import { Volume } from '~/shared/types/api';

import UtilizationChart from '../common/UtilizationChart';
import {
  utilizationDateFilterKey,
  utilizationFullGraphKey,
  utilizationRefreshStateKey,
} from '../common/serachParamKeys';
import useUtilizationQueryParams from '../common/useUtilizationQueryParams';

const Utilization = memo(function Utilization({ volumeId }: { volumeId: Volume['volumeId'] }) {
  const [searchParams, setSearchParams] = useSearchParams();

  const activeRefreshState = searchParams.get(utilizationRefreshStateKey);

  const activeDateFilter = searchParams.get('utilization_date_filter');

  const { utilizationQueryUrl, onRefetchUtilizationQuery } = useUtilizationQueryParams({
    utilizationDateFilterSearchParam: activeDateFilter,
    showFullGraphSearchParam: searchParams.get(utilizationFullGraphKey),
    refreshStateSearchParams: activeRefreshState,
    volumeId,
  });

  return (
    <UtilizationChart
      activeDateFilter={activeDateFilter || 'Last 3 hours'}
      activeRefreshState={activeRefreshState || ''}
      onClickRefresh={onRefetchUtilizationQuery}
      onSelectRefreshState={(item) => {
        setSearchParams(
          (params) => {
            params.set(utilizationRefreshStateKey, item.title);
            return params;
          },
          { replace: true }
        );
      }}
      onSelectDateFilter={(filter) => {
        setSearchParams(
          (params) => {
            params.set(utilizationDateFilterKey, filter.title);
            return params;
          },
          { replace: true }
        );
      }}
      queryUrlString={utilizationQueryUrl}
    />
  );
});

export default Utilization;
